import { AVAILABLE_OFFER_TYPE_COMBINATIONS, AVAILABLE_OFFER_TYPE_COMBINATIONS_SUBURBAN_EXPERIMENT } from '../constants';
import { FOfferType } from '../types';

export function isAvailableOfferTypeCombination(
  offerType: FOfferType,
  isSuburbanCombineSearchEnabled?: boolean,
): boolean {
  // Проверка комбинации AVAILABLE_OFFER_TYPE_COMBINATIONS_SUBURBAN_EXPERIMENT была добавлена в HOM-811.
  // Убрать при раскатке эксперимента
  /* istanbul ignore next */
  const combinations = isSuburbanCombineSearchEnabled
    ? AVAILABLE_OFFER_TYPE_COMBINATIONS_SUBURBAN_EXPERIMENT
    : AVAILABLE_OFFER_TYPE_COMBINATIONS;

  return combinations.some(c => (c & offerType) === offerType);
}
